import { RouteData } from "@sitecore-jss/sitecore-jss-nextjs";

export const isNavbarInverted = (rendering: RouteData): boolean => {
  const templates = ["search page", "get in touch", "faq answer"];
  const templateName = rendering?.templateName?.toLocaleLowerCase();
  return templates.some((tempName) => tempName === templateName);
};
